import React from 'react'
import { Route, Routes, Navigate} from 'react-router-dom'
import Error404Page from './pages/Generales/Error404Page'
import Error401Page from './pages/Generales/Error401Page'
import MessageConfigPage from './pages/MessagesConfigPage'
import FlowBuilderPage from './pages/FlowBuilderPage'
import UserPage from './pages/Mantenedores/UserPage'
import ServicesPage from './pages/Mantenedores/BusinessLinePage'
import RolePage from './pages/Mantenedores/RolePage'
import AccountPage from './pages/Mantenedores/AccountPage'
import TenantPage from './pages/Mantenedores/TenantPage'
import IntegrationReportPage from './pages/IntegrationReportPage'
import ErrorSoonPage from './pages/Generales/ErrorSoonPage'
import DashboardMessagingPage from './pages/DashboardMessagingPage'
import MessagingFlowPage from './pages/MessagingFlowPage'
import FlowAnalizePage from './pages/FlowAnalizePage'
import CampaignListPage from './pages/Campaigns/CampaignListPage'
import TemplateListPage from './pages/Campaigns/TemplateListPage'
import WhatsAppTemplateDetailPage from './pages/Campaigns/WhatsAppTemplateDetailPage'
import ReportCampaignPage from './pages/Campaigns/ReportCampaignPage'
import ReportCampaignDetailPage from './pages/Campaigns/ReportCampaignDetailPage'
import VentaDirectaPreleadsReportPage from './pages/VentaDirectaPreleadsReportPage'
import SmartTalkingLayout from './pages/SmartTalking/SmartTalkingLayout'
import ConversacionesPage from './pages/SmartTalking/ConversacionesPage'
import NotificacionesPage from './pages/SmartTalking/NotificacionesPage'
import ColaEsperaPage from './pages/SmartTalking/ColaEsperaPage'
import ContactosPage from './pages/SmartTalking/ContactosPage'
import SupervisionPage from './pages/SmartTalking/SupervisionPage'
import GestionCarterasPage from './pages/SmartTalking/GestionCarterasPage'
import InformesAIPage from './pages/SmartTalking/InformesAIPage'
import HomePage from './pages/Generales/HomePage'
import SubscriptionPlansPage from './pages/Admin/Saas/SubscriptionPlansPage'
import TokenPackagesPage from './pages/Admin/Saas/TokenPackagesPage'
import CommissionConfigPage from './pages/Admin/Saas/CommissionConfigPage'


const getProfileFromCookies = () => {
    const cookies = document.cookie.split('; ');
    const profileCookie = cookies.find(cookie => cookie.startsWith('perfil='));
    return profileCookie ? decodeURIComponent(profileCookie.split('=')[1]) : null;
};

const getModulesFromCookies = () => {
    const cookies = document.cookie.split('; ');
    const m = cookies.find(c => c.startsWith('modules='));
    if (!m) return [];
    // El cookie viene URL-encodeado (las comas son %2C); decodificar antes de separar.
    return decodeURIComponent(m.split('=')[1]).split(',').map(s => s.trim()).filter(Boolean);
};

const ProtectedRoute = ({ children, requiredModule }) => {
    const perfil = getProfileFromCookies();
    if (perfil === 'Super-Admin') return children;
    const modules = getModulesFromCookies();
    if (!requiredModule || modules.includes(requiredModule)) return children;
    return <Navigate to="/error_no_auth" replace />;
};

// Config SaaS (precios, paquetes de tokens): exclusivo de Super-Admin.
const SuperAdminRoute = ({ children }) => {
    return getProfileFromCookies() === 'Super-Admin'
        ? children
        : <Navigate to="/error_no_auth" replace />;
};

const App = () => {
    //const isProduction = process.env.NODE_ENV === 'production'
    return (
        <Routes>
            <Route path='/flow_messages'  element={<FlowBuilderPage />} />
            <Route path='/flow_messages/messages'  element={<MessageConfigPage />} />
            <Route path='/flow_messages/builder'  element={<FlowBuilderPage />} />
            <Route path='/flow_messages/analize'  element={<FlowAnalizePage />} />
            <Route path='/admin'  element={<ProtectedRoute requiredModule="admin"><ServicesPage /></ProtectedRoute>} />
            <Route path='/admin/services'  element={<ProtectedRoute requiredModule="admin"><ServicesPage /></ProtectedRoute>} />
            <Route path='/admin/users'  element={<ProtectedRoute requiredModule="admin"><UserPage /></ProtectedRoute>} />
            <Route path='/admin/roles'  element={<ProtectedRoute requiredModule="admin"><RolePage /></ProtectedRoute>} />
            <Route path='/admin/accounts'  element={<ProtectedRoute requiredModule="admin"><AccountPage /></ProtectedRoute>} />
            <Route path='/admin/tenants'   element={<ProtectedRoute requiredModule="admin"><TenantPage /></ProtectedRoute>} />
            <Route path='/admin-mobile/subscription-plans' element={<SuperAdminRoute><SubscriptionPlansPage /></SuperAdminRoute>} />
            <Route path='/admin-mobile/token-packages' element={<SuperAdminRoute><TokenPackagesPage /></SuperAdminRoute>} />
            <Route path='/admin-mobile/commission-config' element={<SuperAdminRoute><CommissionConfigPage /></SuperAdminRoute>} />
            <Route path='/integracion' element={<ProtectedRoute requiredModule="integracion"><IntegrationReportPage /></ProtectedRoute>} />
            <Route path='/base_datos'  element={<ProtectedRoute requiredModule="base_datos"><ErrorSoonPage /></ProtectedRoute>} />
            <Route path='/stats'  element={<ProtectedRoute requiredModule="stats"><ErrorSoonPage /></ProtectedRoute>} />
            <Route path='/messaging' element={<ProtectedRoute requiredModule="messaging"><DashboardMessagingPage /></ProtectedRoute>}/>
            <Route path='/messaging/flow/:flowId' element={<ProtectedRoute requiredModule="messaging"><MessagingFlowPage /></ProtectedRoute>}/>
            <Route path='/messaging/flow/:flowId/venta-directa/preleads' element={<ProtectedRoute requiredModule="messaging"><VentaDirectaPreleadsReportPage /></ProtectedRoute>}/>

            <Route path='/campaigns' element={<ProtectedRoute requiredModule="campaigns"><CampaignListPage /></ProtectedRoute>}/>
            <Route path='/campaigns/list' element={<ProtectedRoute requiredModule="campaigns"><CampaignListPage /></ProtectedRoute>}/>
            <Route path='/campaigns/templates' element={<ProtectedRoute requiredModule="campaigns"><TemplateListPage /></ProtectedRoute>}/>
            <Route path='/campaigns/templates/:templateId' element={<ProtectedRoute requiredModule="campaigns"><WhatsAppTemplateDetailPage /></ProtectedRoute>}/>
            <Route path='/campaigns/analize' element={<ProtectedRoute requiredModule="campaigns"><ReportCampaignPage /></ProtectedRoute>}/>
            <Route path='/campaigns/analize/:campaignId' element={<ProtectedRoute requiredModule="campaigns"><ReportCampaignDetailPage /></ProtectedRoute>}/>

            <Route path='/Inicio'  element={<HomePage />} />
            <Route path='*' element={<Error404Page />} />
            <Route path='/coming_soon' element={<ErrorSoonPage />} />
            {window.SHOW_SMART_TALKING && (
            <Route path='/smart_talking' element={<ProtectedRoute requiredModule="smart_talking"><SmartTalkingLayout /></ProtectedRoute>}>
                <Route index element={<Navigate to="conversaciones" replace />} />
                <Route path="conversaciones" element={<ProtectedRoute requiredModule="smart_talking_conversaciones"><ConversacionesPage /></ProtectedRoute>} />
                <Route path="notificaciones" element={<ProtectedRoute requiredModule="smart_talking_notificaciones"><NotificacionesPage /></ProtectedRoute>} />
                <Route path="cola_espera"    element={<ProtectedRoute requiredModule="smart_talking_cola_espera"><ColaEsperaPage /></ProtectedRoute>} />
                <Route path="contactos"      element={<ProtectedRoute requiredModule="smart_talking_contactos"><ContactosPage /></ProtectedRoute>} />
                <Route path="supervision"    element={<ProtectedRoute requiredModule="smart_talking_supervision"><SupervisionPage /></ProtectedRoute>} />
                <Route path="gestion_carteras" element={<ProtectedRoute requiredModule="smart_talking_supervision"><GestionCarterasPage /></ProtectedRoute>} />
                <Route path="informes_ai"    element={<ProtectedRoute requiredModule="smart_talking_informes_ai"><InformesAIPage /></ProtectedRoute>} />
            </Route>
            )}

            {/* Ruta de error */}
            <Route path="/error_no_auth" element={<Error401Page />} />
            
        </Routes>
    );
}

export default App;